<template>
  <apexchart type="line" :options="densityChart" :series="densitySeries" :height="height" :width="width"></apexchart>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

Vue.component("apexchart", VueApexCharts);

export default {
  props: {
    densitySeries: Array,
    height: Number,
    width: Number,
  },
  data() {
    return {
      densityChart: {
        chart: {
          id: "density",
          group: "smp",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
          theme: true,
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "bottom",
          labels: {
            colors: "primary",
          },
        },
        yaxis: {
          tickAmount: 6,
          max: 800,
          axisTicks: {
            show: true,
          },
          labels: {
            offsetX: -17,
            style: {
              fontSize: "12px",
              colors: "primary",
            },
            formatter: (val) => {
              return val.toFixed(2) + " ug/m³";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
    };
  },
};
</script>